import config from 'config'
import lang from '@/lang'
import moment from 'moment'

import { recurringInvoiceStates } from '@/modules/base/util/constants'
const { DRAFT, STARTED, FINISHED } = recurringInvoiceStates

const urls = {
  single: 'recurringinvoice',
  multiple: 'recurringinvoices',
}

const resourceUrl = `${config.resourceHost}recurringinvoice`

export default {
  resourceUrl,
  recurringInvoiceListSetting: `${config.resourceHost}setting/userlist/recurringInvoice`,

  clientUrl: urls,
  getNewRecurringInvoice: `${resourceUrl}/new`,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: 'draft',
      title: lang.draft,
      quickFilter: {
        state: {
          type: 'set',
          values: [DRAFT],
        },
      },
    },

    { name: 'started',
      title: 'Gestartet',
      quickFilter: {
        state: {
          type: 'set',
          values: [STARTED],
        },
      },
    },
    { name: 'within30Days',
      title: 'Nächste 30 Tage',
      quickFilter: {
        nextDate: {
          dateFrom: moment().startOf('day').toISOString(),
          dateTo: moment().add(30, 'days').startOf('day').toISOString(),
          filterType: 'date',
          type: 'inRange',
        },
      },
    },
    { name: 'finished',
      title: 'Beendet',
      quickFilter: {
        state: {
          type: 'set',
          values: [FINISHED],
        },
      },
    },
  ],
}
